import * as React from 'react';
import {Datagrid, List, ListProps, EditButton, ReferenceField, BooleanField} from 'react-admin';
import {Fragment, ReactElement} from 'react';
import { Route } from 'react-router';

import MaterialConfigFilter from "./MaterialConfigFilter";
import MaterialConfigCreate from "./MaterialConfigCreate";
import MaterialConfigEdit from "./MaterialConfigEdit";
import SideDrawer from "../../../components/list/SideDrawer";
import TextField from "../../../components/list/TextField";
import ListActions from "../../../components/list/ListActions";

const MaterialConfigList = (props: ListProps): ReactElement => {

    return (
        <Fragment>
            <List {...props} filters={<MaterialConfigFilter/>} sort={{field: 'id', order: 'DESC'}} actions={<ListActions/>}>
                <Datagrid>
                    <TextField source="id"/>
                    <ReferenceField label={"resources.admin/lod-price-matrix.fields.material"} source="material_id" reference="admin/lod-materials" sortable={false}>
                        <TextField source="name_lt"/>
                    </ReferenceField>
                    <BooleanField source="material_is_available" looseValue={true}/>
                    <ReferenceField label={"resources.admin/lod-price-matrix.fields.thickness"} source="thickness_id" reference="admin/lod-thickness" sortable={false}>
                        <TextField source="value"/>
                    </ReferenceField>
                    <EditButton/>
                </Datagrid>
            </List>
            <Route path={`${props.basePath}/create`}>
                {({ match }) => {
                    return (
                        <SideDrawer open={!!match} basePath={props.basePath??''}>
                            <MaterialConfigCreate {...props} />
                        </SideDrawer>
                    )
                }}
            </Route>
            <Route path={`${props.basePath}/:id`}>
                {({ match }) => {
                    const isMatch = !!(match && match.params && match.params.id !== 'create');
                    return (
                        <SideDrawer open={isMatch} basePath={props.basePath??''}>
                            {isMatch && (
                                <MaterialConfigEdit id={match && isMatch ? match.params.id : undefined}{...props}/>
                            )}
                        </SideDrawer>
                    );
                }}
            </Route>
        </Fragment>
    );
};

export default MaterialConfigList;
